import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";

const moduleSelector = (state: IRootState) => state.internetConnection;

export const getIsInternetConnectionModuleInited = createSelector(
        moduleSelector, state => state.isInited,
);

export const getInternetConnectionSpeedKbps = createSelector(
        moduleSelector, state => state.speedKbps,
);

export const getIsInternetConnectionSlow = createSelector(
        moduleSelector, state => state.speedKbps < 80,
);

export const getOnlineStatus = createSelector(
    moduleSelector, state => state.online,
);
